import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    submitPerpayPlusSoloApplication,
    submitPerpayPlusSoloApplicationError,
    submitPerpayPlusSoloApplicationReset,
    submitPerpayPlusSoloApplicationSuccess,
} from '@perpay-web/fintech/actions/entities/perpayPlusSolo';
import { PERPAY_PLUS_SOLO_SUBMIT_APPLICATION_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useSubmitPerpayPlusSoloApplicationDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(
            PERPAY_PLUS_SOLO_SUBMIT_APPLICATION_ENDPOINT,
            payload,
            HTTPMethod.post,
        ).then((response) => {
            const DUPLICATE_SSN =
                response.result === 'failed' && response.ssnInUse;
            const IDV_FAILED =
                response.result === 'failed' &&
                response.idvFailed &&
                !response.maxAttemptsReached;

            // Check for Duplicate SSN or IDV Failed
            if (DUPLICATE_SSN || IDV_FAILED) {
                return Promise.reject(new Error(response.message));
            }

            return response;
        }),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: submitPerpayPlusSoloApplication,
        error: submitPerpayPlusSoloApplicationError,
        success: submitPerpayPlusSoloApplicationSuccess,
        reset: submitPerpayPlusSoloApplicationReset,
    });

    return { ...dataModule };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useSubmitPerpayPlusSoloApplicationDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseSubmitPerpayPlusSoloApplicationDataModuleProvider,
    useSubmitPerpayPlusSoloApplicationContext,
] = createContextProvider(providerFactory);
